var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _path7, _g3, _path8, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadExcel(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 51,
    viewBox: "0 0 49 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.99 3.036a.898.898 0 0 0-.774-.184L3.538 8.388a.92.92 0 0 0-.706.907v31.376c0 .454.329.842.774.913l23.678 3.689a.909.909 0 0 0 1.037-.771l.011-.139V3.76a.926.926 0 0 0-.343-.723z",
    fill: "#46CC88"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "dl5vpnv53a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 7,
    width: 18,
    height: 35
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.205 7.08v34.088h16.833c.462 0 .841-.402.841-.898V7.98c0-.493-.38-.898-.841-.898H26.205z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dl5vpnv53a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.91-4.629v1.48h39.94V51.4H15.39V-4.63h-1.48v1.48-1.48h-1.478v58.987h44.375V-6.108H12.432v1.48h1.479z",
    fill: "#46CC88"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ajy92bt9bb",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 7,
    width: 18,
    height: 35
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.205 7.08v34.088h16.833c.462 0 .841-.402.841-.898V7.98c0-.493-.38-.898-.841-.898H26.205z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ajy92bt9bb)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3129.45 1912.33v1.48H169.851V-197.132H-3130.93V1913.81h1.48v-1.48h1.48V-194.174H166.89V1910.85h-3296.34v1.48h1.48-1.48z",
    fill: "#46CC88"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.204 8.561h16.833v-.583h-.638c0 .252.21.57.638.583v-.583h-.638v32.291h.638v-.58c-.428.014-.638.331-.638.58h.638v-.58H26.204v2.958h16.833c1.357-.015 2.318-1.134 2.32-2.378V7.978c-.002-1.241-.963-2.36-2.32-2.375H26.204v2.958z",
    fill: "#46CC88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.333 14.17h14.41V11.3h-14.41M28.338 19.859h14.41v-2.87h-14.41M28.291 25.492h14.41v-2.87h-14.41M28.338 31.153h14.41v-2.87h-14.41M28.338 36.846h14.41v-2.87h-14.41",
    fill: "#46CC88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.998 8.412v34.043h2.833V8.412",
    fill: "#46CC88"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "of60lwj4qc",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 16,
    width: 11,
    height: 18
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.444 16.85c-.403.286-.51.864-.241 1.295l8.786 14.906a.87.87 0 0 0 .742.436.823.823 0 0 0 .465-.142c.41-.269.538-.844.283-1.28l-8.786-14.91c-.008-.016-.02-.03-.031-.05a.863.863 0 0 0-.728-.411c-.17 0-.34.051-.49.156z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#of60lwj4qc)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.992 45.535h34.649V4.647h-34.65v40.888z",
    fill: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "f7b2x969ad",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 16,
    width: 11,
    height: 18
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m18.991 17.156-8.786 14.906a.99.99 0 0 0-.136.493c0 .513.394.932.879.932a.876.876 0 0 0 .748-.439l8.783-14.906a.77.77 0 0 1 .031-.051c.244-.448.1-1.015-.32-1.272a.812.812 0 0 0-.44-.128c-.302 0-.6.167-.759.465z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f7b2x969ad)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.976 45.535h34.652V4.644H-1.976v40.89z",
    fill: "#FAFAFA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadExcel);
export default __webpack_public_path__ + "static/media/upload-excel.35d213cf.svg";
export { ForwardRef as ReactComponent };